import { useQuery, useMutation } from 'react-query'
import useStaleTimes from '../use-stale-times'
import useCacheKeys from '../use-cache-keys'
import moment from 'moment'
import { apiEndpoints, apiRequester } from '../../utilities/api'

const useUserCourseRatings = ({
    limit = 1,
    mode = 'open',
    userId,
    startDate = moment().subtract(1, 'weeks').format('YYYY-MM-DD')
} = {}) => {
    const staleTimes = useStaleTimes()
    const cacheKeys = useCacheKeys()
    const {
        data,
        isLoading, isFetching
    } = useQuery(
        [cacheKeys.SURVEYS, 'course', userId, limit, mode, startDate],
        () => apiRequester.get(apiEndpoints.userCourseRatings({ userId }, { limit, mode, sd: startDate })),
        { enabled: userId, staleTime: staleTimes.MINUTE * 5 }
    )

    return {
        userCourseRatings: data ? data.items : [],
        isLoading: isLoading || isFetching,
    }
}

export default useUserCourseRatings